<section class="founding-circle section">
  <div class="founding-circle__inner container">
    <h2 class="founding-circle__title title">Founding Circle</h2>

    <div class="founding-circle__content">
      <p class="founding-circle__intro subheading">
        We have been developing EVRN since the early days of 2025 with a group of more than 250
        filmmakers, creatives, and pipeline designers who have been advising us. We are indebted to
        them, and grateful for their patience, their time, and the feedback they gave us through our
        endless iterations. A few of them are named here.
      </p>

      <p class="founding-circle__names subheading">
        Kevin Tod Haug, Alex McDowell, Lindsey Robbins, Johannes Saam, Tristan King, Sagans, David
        Monguet, Krystian Wydro, Jose Alex Guedes, Michel Suissa, Jordan Muthra, King Willonius,
        Team Anima Studios, Frankie Caradonna, Elena Dimopoulou, Roni Beraha, Utku Atalay, Ankit
        Aurora, Adrianna Cohen, Scott Bryant, Ian Messina, Aaron Randall, Alex G, Angie Jones,
        Arijiit Das, Artur Arepyev, Asad Ahmed, Baris Cihan Pesmen, Carmelo M, Chaitanya K,
        Christopher Jorna, Christian Venables, Darien Davis, Darion D'Anjou, David Monguet, David
        Tveraas, Frank Bazuaye, Iris Magdalene Schmidt, Jonathan Masterson, Kursad Karatas, Maria
        Guerberof, Marilina Garcia Alchurut, Mike Jones, Madhushree Purohit, Nancy Joann Atanassov,
        Nina Sabina Caballero, Pierre Rinaldi-Doligez, Ralph Tompkins, Roos Van der Jagt, Tapan
        Aslot, Utku Atalay, Victory Igboanu, Vinod Padmanabhan Vijay Kumar, Mahmoud Wagdy, Yigit
        Karabag, and Tiago Martinez.
      </p>
    </div>
  </div>
</section>
